document.addEventListener("DOMContentLoaded", () => {
  document.body.removeAttribute('style');
  document.querySelectorAll('.layout-icon').forEach(icon => {
    if ((innerWidth < 768 && document.body.classList.contains('template-suffix-sale-layout')) || (innerWidth < 768 && document.body.classList.contains('template-search'))) {
      document.querySelector('.collection-container').classList.remove('product-grid-basic');
      document.querySelector('.collection-container').classList.add('product-grid-6');
      document.querySelector('.layout-icon.layout-icon-one').classList.remove('active');
      document.querySelector('.layout-icon.layout-icon-two').classList.add('active');
    }
  
    icon.addEventListener('click', () => {
      const productGrid = document.querySelector('.collection-container');
      ['product-grid-basic', 'product-grid-6', 'product-grid-12'].forEach(cls => {
        if (cls !== icon.dataset.layout) productGrid.classList.remove(cls);
      });
      productGrid.classList.add(icon.dataset.layout);
      document.querySelectorAll('.layout-icon').forEach(i => i.classList.remove('active'));
      icon.classList.add('active');
    });
  });
});
